<h1 mat-dialog-title>{{ 'dialog.confirmationTitle' | translate }}</h1>
<div mat-dialog-content style="white-space: pre-line;" [innerText]="message">
</div>
<div mat-dialog-actions style="padding: 24px;">
  <button mat-raised-button color="primary"
          [mat-dialog-close]="true">{{ confirmText ? confirmText : 'dialog.yesButton' | translate }}
  </button>
  <button mat-raised-button color="warn"
          [mat-dialog-close]="false">{{
      cancelText ? cancelText : 'dialog.cancelButton' | translate
    }}
  </button>
</div>
